import { render, staticRenderFns } from "./RegionAmountMoneySalesCmp.vue?vue&type=template&id=22042f0f&"
import script from "./RegionAmountMoneySalesCmp.vue?vue&type=script&lang=js&"
export * from "./RegionAmountMoneySalesCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports